import $ from 'jquery';
import 'whatwg-fetch';
import { polyfill } from 'es6-promise';
import Game from './game';
import Quotes from './quotes';
import Recipes from './recipes';

polyfill();

const game = new Game();
const quotes = new Quotes();
const recipes = new Recipes();

$(() => {
	game.init();
	quotes.init();
	recipes.init();
});



// WEBPACK FOOTER //
// ./app/scripts/app.js